import { pushCustomEvent } from 'utils/analytics';

export const pushHeaderEvent = (action, label, deviceType) => {
  const preparedOptions = {
    action,
    label,
    deviceType,
  };

  if (!label) {
    delete preparedOptions.label;
  }

  pushCustomEvent('ndrsn_main_menu', preparedOptions);
};

export const handleLinkClick = (url, deviceType = 'Desktop') => {
  const preparedLabel = url.startsWith('https://andersenlab.com')
    ? url.replace('https://andersenlab.com', '')
    : url;
  pushHeaderEvent('click_on_link', preparedLabel, deviceType);
};
